import './assets/css/style.css';
import './assets/css/style-preset.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './Components/Home';
import Dashboard from './Components/Layout/Dashboard';
import UserList from './Components/Users/UserList';
import AllCallLog from './Components/Users/AllCallLog';
import UserCallLog from './Components/Users/CallLog';
import AddUser from './Components/Users/AddUser';
import AddAccounts from './Components/Accounts/AddAccounts';
import AccountsList from './Components/Accounts/AccountsList';
import UpdateAccounts from './Components/Accounts/UpdateAccounts';
import ViewAccounts from './Components/Accounts/ViewAccounts';
import ViewEditPO from './Components/AccountsDashboard/ViewEditPO';
import POStatus from './Components/AccountsDashboard/POStatus';
import POHistory from './Components/AccountsDashboard/POHistory';
import ViewPO from './Components/AccountsDashboard/ViewPO';
import EditPO from './Components/AccountsDashboard/EditPO';
import Login from './Components/Auth/Login';
import Register from './Components/Auth/Register';
import Profile from './Components/Auth/Profile';
import UserView from './Components/Users/UserView';
import CmsList from './Components/CMS/CmsList';
import AddCms from './Components/CMS/AddCms';
import ProtectedRoute from './Components/Routes/ProtectedRoute';
import UserUpdate from './Components/Users/UserUpdate';
import ViewCms from './Components/CMS/ViewCms';
import EditCms from './Components/CMS/EditCms';
import ErrorPage from './Components/Page404/ErrorPage';
import RouteList from './Components/RouteManage/RouteList';
import RouteAdd from './Components/RouteManage/RouteAdd';
import RouteDetails from './Components/RouteManage/RouteDetails';
import RouteEdit from './Components/RouteManage/RouteEdit';
import ContactTypeList from './Components/ContactType/ContactTypeList';
import ContactTypeAdd from './Components/ContactType/ContactTypeAdd';
import ContactTypeView from './Components/ContactType/ContactTypeView';
import ContactTypeEdit from './Components/ContactType/ContactTypeEdit';
import POTypeList from './Components/POType/POTypeList';
import POTypeAdd from './Components/POType/POTypeAdd';
import POTypeEdit from './Components/POType/POTypeEdit';
import ProductMasterList from './Components/ProductMaster/ProductMasterList';
import ProductMasterAdd from './Components/ProductMaster/ProductMasterAdd';
import ProductMasterEdit from './Components/ProductMaster/ProductMasterEdit';
import ManagerList from './Components/Manager/ManagerList';
import AdminList from './Components/Admin/AdminList';
import CallLog from './Components/Manager/CallLog';
import AddManager from './Components/Manager/AddManager';
import ManagerUpdate from './Components/Manager/ManagerUpdate';
import ManagerView from './Components/Manager/ManagerView';
import CustomerList from './Components/Customer/CustomerList';
import CustomerView from './Components/Customer/CustomerView';
import CustomerCreate from './Components/Customer/CustomerCreate';
import CustomerUpdate from './Components/Customer/CustomerUpdate';
import ComplaintList from './Components/Complaint/List';
import ComplaintView from './Components/Complaint/View';
import BeatView from './Components/BeatPlan/View';
import BeatList from './Components/BeatPlan/List';
import Password from './Components/Auth/Password';
import UserVisitLog from './Components/Users/VisitLog';
import ManagerVisitLog from './Components/Manager/VisitLog';
import CompanyList from './Components/Company/CompanyList';
import CompanyAdd from './Components/Company/CompanyAdd';
import CompanyView from './Components/Company/CompanyView';
import CompanyEdit from './Components/Company/CompanyEdit';
import VisitLogList from './Components/Manager/VisitLogList';
import InvoicingDataLog from './Components/Reports/InvoicingDataLog';


function App() {
  return (
    <>
      {/* <h1>!! Jai Shree Ram !!</h1> */}
      <BrowserRouter>
        <Routes>
          <Route path='*' element={<ErrorPage />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/' element={<ProtectedRoute component={Dashboard} />}>
            <Route index element={<ProtectedRoute component={Home }/>} />
            <Route path='/profile' element={<ProtectedRoute component={Profile} />} />
            <Route path='/password' element={<ProtectedRoute component={Password} />} />

            {/* user Management start */}
            <Route path='/users/user-list' element={<ProtectedRoute component={UserList} />} />
            <Route path='/users/add-user' element={<ProtectedRoute component={AddUser} />} />
            <Route path='/users/call-log/:id' element={<ProtectedRoute component={UserCallLog} />} />
            <Route path='/users/visit-log/:id' element={<ProtectedRoute component={UserVisitLog} />} />
            <Route path='/users/view-user/:id' element={<ProtectedRoute component={UserView} />} />
            <Route path='/users/update-user/:id' element={<ProtectedRoute component={UserUpdate} />} />
            {/* user Management end */}

            {/* Accounts Management start */}
            <Route path='/accounts/accounts-list' element={<ProtectedRoute component={AccountsList} />} />
            <Route path='/accounts/add-accounts' element={<ProtectedRoute component={AddAccounts} />} />
            <Route path='/accounts/update-accounts/:id' element={<ProtectedRoute component={UpdateAccounts} />} />
            <Route path='/accounts/view-accounts/:id' element={<ProtectedRoute component={ViewAccounts} />} />
            
            {/* Accounts Dashboard */}
            <Route path='/accounts-dashboard/view-edit' element={<ProtectedRoute component={ViewEditPO} />} />
            <Route path='/accounts-dashboard/status' element={<ProtectedRoute component={POStatus} />} />
            <Route path='/accounts-dashboard/history' element={<ProtectedRoute component={POHistory} />} />
            <Route path='/accounts-dashboard/view-po/:id' element={<ProtectedRoute component={ViewPO} />} />
            <Route path='/accounts-dashboard/edit-po/:id' element={<ProtectedRoute component={EditPO} />} />
            {/* Accounts Management end */}


              {/* Manager Management start */}
            <Route path='/manager/manager-list' element={<ProtectedRoute component={ManagerList} />} />
            <Route path='/admin/admin-list' element={<ProtectedRoute component={AdminList} />} />
            <Route path='/manager/add-manager' element={<ProtectedRoute component={AddManager} />} />
            <Route path='/manager/view-manager/:id' element={<ProtectedRoute component={ManagerView} />} />
            <Route path='/manager/call-log/:id' element={<ProtectedRoute component={CallLog} />} />
            <Route path='/manager/visit-log/:id' element={<ProtectedRoute component={ManagerVisitLog} />} />


            <Route path='/visit-log/list' element={<ProtectedRoute component={VisitLogList} />} />



            <Route path='/call-log/list' element={<ProtectedRoute component={AllCallLog} />} />
            

            <Route path='/manager/update-manager/:id' element={<ProtectedRoute component={ManagerUpdate} />} />
            {/* Manager Management end */}


            <Route path='/customer/customer-list' element={<ProtectedRoute component={CustomerList} />} />
            <Route path='/customer/view-customer/:id' element={<ProtectedRoute component={CustomerView} />} />
            <Route path='/customer/customer-create' element={<ProtectedRoute component={CustomerCreate} />} />
            <Route path='/customer/customer-update/:id' element={<ProtectedRoute component={CustomerUpdate} />} />


            <Route path='/complaint/complaint-list' element={<ProtectedRoute component={ComplaintList} />} />
            <Route path='/complaint/view-complaint/:id' element={<ProtectedRoute component={ComplaintView} />} />
            <Route path='/beat/list' element={<ProtectedRoute component={BeatList} />} />
            <Route path='/beat/view/:id' element={<ProtectedRoute component={BeatView} />} />



            {/* route Management start */}
            <Route path='/routes/route-list' element={<ProtectedRoute component={RouteList} />} />
            <Route path='/routes/add-route' element={<ProtectedRoute component={RouteAdd} />} />
            <Route path='/routes/view-route/:id' element={<ProtectedRoute component={RouteDetails} />} />
            <Route path='/routes/update-route/:id' element={<ProtectedRoute component={RouteEdit} />} />
            {/* route Management end */}


            <Route path='/company/company-list' element={<ProtectedRoute component={CompanyList} />} />
            <Route path='/company/add-company' element={<ProtectedRoute component={CompanyAdd} />} />
            <Route path='/company/view-company/:id' element={<ProtectedRoute component={CompanyView} />} />
            <Route path='/company/update-company/:id' element={<ProtectedRoute component={CompanyEdit} />} />


            {/* contact type Management start */}
            <Route path='/contacttypes/contacttype-list' element={<ProtectedRoute component={ContactTypeList} />} />
            <Route path='/contacttypes/add-contacttype' element={<ProtectedRoute component={ContactTypeAdd} />} />
            <Route path='/contacttypes/view-contacttype/:id' element={<ProtectedRoute component={ContactTypeView} />} />
            <Route path='/contacttypes/update-contacttype/:id' element={<ProtectedRoute component={ContactTypeEdit} />} />
            {/* contact type Management end */}

            {/* po type Management start */}
            <Route path='/po-types/po-type-list' element={<ProtectedRoute component={POTypeList} />} />
            <Route path='/po-types/add-po-type' element={<ProtectedRoute component={POTypeAdd} />} />
            <Route path='/po-types/update-po-type/:id' element={<ProtectedRoute component={POTypeEdit} />} />
            {/* po type Management end */}

            {/* product master Management start */}
            <Route path='/product-master/product-list' element={<ProtectedRoute component={ProductMasterList} />} />
            <Route path='/product-master/add-product' element={<ProtectedRoute component={ProductMasterAdd} />} />
            <Route path='/product-master/update-product/:id' element={<ProtectedRoute component={ProductMasterEdit} />} />
            {/* product master Management end */}

            {/* cms Management start */}
            <Route path='/cms/cms-list' element={<ProtectedRoute component={CmsList} />} />
            <Route path='/cms/add-cms' element={<ProtectedRoute component={AddCms} />} />
            <Route path='/cms/view-cms/:slug' element={<ProtectedRoute component={ViewCms} />} />
            <Route path='/cms/update-cms/:slug' element={<ProtectedRoute component={EditCms} />} />
            {/* cms Management end */}
            
            {/* Reports */}
            <Route path='/reports/invoicing-data-log' element={<ProtectedRoute component={InvoicingDataLog} />} />


          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer autoClose={2000} />
    </>
  );
}

export default App;
